import React from "react";
import { Button } from "../../components";
import OfficeFinanceTabGraphSection from "../../components/Finance/OfficeFinanceTabGraphSection";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { formatCurrency } from "../../utils";
import DataNotFound from "../../components/DataNotFound/DataNotFound";
import NotFound from "../../assets/images/no-financial.png";

const AnnualPlan = ({ hideAnnualSubscribers = false, key }: { key?: string; hideAnnualSubscribers?: boolean }) => {
  const { currentOffice } = useSelector((state: RootState) => state.office);
  const { annualPlanTotals, annualPlanRevenueByPlan } = useSelector((state: RootState) => state.finance);
  const noRecordFound = !(
    annualPlanTotals?.annualPlanRevenue ||
    annualPlanTotals?.monthlyAnnualPlanSubscribers ||
    annualPlanTotals?.revenueGenerated ||
    annualPlanTotals?.yearlyAnnualPlanSubscribers
  );
  if (noRecordFound) return <DataNotFound image={NotFound} text="No financial records found" />;
  return (
    <div key={key}>
      {/* Header Start */}
      <div className="px-6 py-5 bg-docsigna-pink-light mb-10 rounded-b-xl rounded-tr-xl relative">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-2">
          <div>
            <div className="flex justify-between items-center border py-1 border-x-0 border-t-0 border-dotted border-docsigna-purple">
              <h3 className="text-lg font-medium text-docsigna-purple">Annual Plan Revenue - Year to Date</h3>
              <h3 className="text-lg font-medium text-docsigna-purple">
                {annualPlanTotals?.annualPlanRevenue ? formatCurrency((annualPlanTotals.annualPlanRevenue / 100)?.toString(), "blur") : "$0.00"}
              </h3>
            </div>
            <div className="flex justify-between items-center border py-1 border-x-0 border-t-0 border-dotted border-docsigna-purple">
              <h3 className="text-lg font-medium text-docsigna-purple">Revenue Generated - This Month</h3>
              <h3 className="text-lg font-medium text-docsigna-purple">
                {annualPlanTotals?.revenueGenerated ? formatCurrency((annualPlanTotals.revenueGenerated / 100)?.toString(), "blur") : "$0.00"}
              </h3>
            </div>
            <div className="flex justify-between items-center border py-1 border-x-0 border-t-0 border-dotted border-docsigna-purple">
              <h3 className="text-lg font-medium text-docsigna-purple">Annual Plan Refund</h3>
              <h3 className="text-lg font-medium text-docsigna-purple">
                {annualPlanTotals?.refundAmount ? formatCurrency((annualPlanTotals?.refundAmount / 100)?.toString(), "blur") : "$0.00"}
              </h3>
            </div>
          </div>
          <div>
            <div className="flex justify-between items-center border py-1 border-x-0 border-t-0 border-dotted border-docsigna-purple">
              <h3 className="text-lg font-medium text-docsigna-purple">Yearly Annual Plan Subscribers</h3>
              <h3 className="text-lg font-medium text-docsigna-purple">
                {annualPlanTotals?.yearlyAnnualPlanSubscribers ? annualPlanTotals.yearlyAnnualPlanSubscribers.toString() : "0"}
              </h3>
            </div>
            <div className="flex justify-between items-center border py-1 border-x-0 border-t-0 border-dotted border-docsigna-purple">
              <h3 className="text-lg font-medium text-docsigna-purple">Monthly Annual Plan Subscribers</h3>
              <h3 className="text-lg font-medium text-docsigna-purple">
                {annualPlanTotals?.monthlyAnnualPlanSubscribers ? annualPlanTotals.monthlyAnnualPlanSubscribers.toString() : "0"}
              </h3>
            </div>
          </div>
        </div>
        {!hideAnnualSubscribers ? (
          <div>
            <p className="py-5 text-lg text-docsigna-purple font-medium text-center">Select the link below for a full list of your subscribers </p>
            {currentOffice?.officeId ? (
              <div className="flex w-full absolute -bottom-4 left-0 items-center justify-center text-center">
                <Link to={`/offices/${currentOffice.officeId}/plans?activeTab=subscribers`}>
                  <Button
                    text="Annual Subscribers"
                    className="bg-docsigna-orange border-docsigna-orange text-white hover:text-docsigna-orange px-10"
                    onClick={() => null}
                  />
                </Link>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
      {/* Header End */}
      {annualPlanRevenueByPlan ? <OfficeFinanceTabGraphSection annualPlanRevenueByPlan={annualPlanRevenueByPlan} /> : null}
    </div>
  );
};

export default AnnualPlan;
